import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    message: String
  }

  check(event) {
    const message = this.messageValue || "Are you sure? This action cannot be undone."

    if (!confirm(message)) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }
}
